var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animation",class:{
    'is-desktop': _vm.isDesktop,
    'is-mobile': !_vm.isDesktop,
    'is-fallback': _vm.useFallback
  }},[_c('div',{ref:"container",staticClass:"three-animation"}),_vm._t("default"),(_vm.debug)?_c('div',{staticClass:"ratio"},[_vm._v(_vm._s(_vm.ratio))]):_vm._e(),(_vm.debug)?_c('div',{staticClass:"debug-range"},[_c('input',{attrs:{"type":"range","min":"0","max":"100","step":"0.001","value":"0"},on:{"input":_vm.handleRange}})]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }